import ReactGA from 'react-ga';

export const initializeGA = () => {
  const trackingId = 'UA-198551137-1';
  ReactGA.initialize(trackingId);
  ReactGA.pageview(window.location.pathname + window.location.search);
};
